// extracted by mini-css-extract-plugin
export default {"Container":"CarrierView_Container__NVEFp","Header":"CarrierView_Header__Ay6vj","Centered":"CarrierView_Centered__jb+AI"};